import { type SVGProps, useId } from "react";

/** Flag of Slovakia, drawn in a 4:3 box shared by every flag in this folder.
 * The coat of arms is simplified — recognizable at icon sizes, not heraldic. */
export function FlagSk(props: SVGProps<SVGSVGElement>) {
  // The hills are clipped to the shield, so the clip path id must stay unique
  // across every rendered instance.
  const clipId = useId();
  const shield =
    "M11,9.5 H32 V27 C32,31.5 27.5,34 21.5,35.5 C15.5,34 11,31.5 11,27 Z";

  return (
    <svg viewBox="0 0 60 45" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="60" height="15" fill="#ffffff" />
      <rect y="15" width="60" height="15" fill="#0b4ea2" />
      <rect y="30" width="60" height="15" fill="#ee1c25" />
      <clipPath id={clipId}>
        <path d={shield} />
      </clipPath>
      <g clipPath={`url(#${clipId})`}>
        <path d={shield} fill="#ee1c25" />
        {/* Double cross: stem with a shorter upper and longer lower arm. */}
        <path
          d="M20.1,12.5 h2.8 v18.5 h-2.8 Z M16.7,15.8 h9.6 v2.8 h-9.6 Z M15.2,21.4 h12.6 v2.8 h-12.6 Z"
          fill="#ffffff"
        />
        {/* Three hills the cross stands on. */}
        <ellipse cx="13.5" cy="35" rx="5.5" ry="4.5" fill="#0b4ea2" />
        <ellipse cx="29.5" cy="35" rx="5.5" ry="4.5" fill="#0b4ea2" />
        <ellipse cx="21.5" cy="34" rx="5.2" ry="5" fill="#0b4ea2" />
      </g>
      <path d={shield} fill="none" stroke="#ffffff" strokeWidth="1.6" />
    </svg>
  );
}
